import React, { forwardRef } from "react";
import { ModalContent } from "./ModalContent";
import { ConfirmModal } from "./ConfirmModal";
import { Box, Modal } from "@mui/material";
import Snackbar from "components/Snackbar/Snackbar";
import { useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";

export const ModalV2 = forwardRef((props, ref) => {
  const {
    open,
    onClose,
    layoutStyle,
    justConfirm = false,
    showSnackbar = true,
  } = props;
  const { isOpen, message, color, position } = useSelector(
    ({ search }) => search
  );
  const { clearSnackbar } = useSearch();

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowY: "scroll",
        ...layoutStyle,
      }}
    >
      <>
        <Box ref={ref} style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          {justConfirm ? (
            <ConfirmModal {...props} />
          ) : (
            <ModalContent {...props} />
          )}
        </Box>
        {showSnackbar && (
          <Snackbar
            place={position}
            color={color}
            message={message}
            open={isOpen}
            closeNotification={clearSnackbar}
            close
          />
        )}
      </>
    </Modal>
  );
});
